import { EventEmitter } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
var CounterInputComponent = /** @class */ (function () {
    function CounterInputComponent() {
        this.layoutFormat = 'mini-ibe';
        this.valueIncrement = new EventEmitter();
        this.valueDecrement = new EventEmitter();
        this.typePassengersAriaAlert = '';
        // required for ControlValueAccessor
        this.propagateChange = function (_) { };
    }
    Object.defineProperty(CounterInputComponent.prototype, "counterValue", {
        /**
         * counter value getter
         * Use on template
         */
        get: function () {
            return this._counterValue;
        },
        /**
         * Counter Value setter
         * guards against overflow and underflow
         * Propagates changes to Parent throught formcontrol
         */
        set: function (val) {
            val = +val;
            if (val < this.min) {
                this._counterValue = this.min;
            }
            else {
                this._counterValue = val;
            }
            this.propagateChange(this._counterValue);
            this.typePassengersAriaAlert = this._counterValue + ' ' + this.label + ' selected.';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * counter value incrementer
     * Use on template
     */
    CounterInputComponent.prototype.increment = function () {
        if (this.counterValue < this.max) {
            this.counterValue++;
        }
        this.valueIncrement.emit(this.formControlName);
    };
    /**
     * counter value incrementer
     * Use on template
     */
    CounterInputComponent.prototype.decrement = function () {
        if (this.counterValue > this.min) {
            this.counterValue--;
        }
        this.valueDecrement.emit(this.formControlName);
    };
    CounterInputComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    CounterInputComponent.prototype.registerOnTouched = function (fn) { };
    CounterInputComponent.prototype.writeValue = function (value) {
        this.counterValue = value;
    };
    CounterInputComponent.prototype.INDRA_disableIncrement = function (type) {
        if (this.setIncrementToDisable === 'enable10Days' && this.counterValue == this.max) {
            return true;
        }
        else {
            if (this.counterValue == this.counterValue + this.max) {
                return true;
            }
            if (this.setIncrementToDisable[type]) {
                return true;
            }
        }
        return false;
    };
    CounterInputComponent.prototype.INDRA_disableDecrement = function (type) {
        if (this.counterValue == this.min) {
            return true;
        }
        if (this.setDecrementToDisable[type]) {
            return true;
        }
        return false;
    };
    return CounterInputComponent;
}());
export { CounterInputComponent };
